import type { Ceviri, MotorP } from "../../tip";
import type { olcu as tr } from "../../tr/motor/olcu";

/** English dictionary · engine messages · olcu. */
export const olcu: Ceviri<typeof tr> = {
  "olcu.sepetElleDegerlenen": () => "manual valuation",
  "olcu.sepetListedeYok": () => "not in the list or still being prepared",
  "olcu.sepetDegerOlculemedi": () => "value could not be measured",
  "olcu.sepetDegerSifir": () => "value is zero",
  "olcu.sepetIlkDisinda": (p: MotorP) => `outside the top ${p.sayi}`,

  "olcu.toplamDegerYok": () => "No total value.",
  "olcu.toplamMaliyetYok": () => "No total cost.",
  "olcu.kazancToplamiYok": () => "No total gain.",
  "olcu.maliyetSifirOranYok": () => "Cost is zero: no rate.",
  "olcu.getiriYok": () => "No return.",

  "olcu.adGetiri": () => "return",
  "olcu.adPortfoyDegeri": () => "portfolio value",
  "olcu.gunIcinHesaplanmamis": (p: MotorP) => `${p.ad} not calculated for ${p.gun}.`,
  "olcu.gunAlanOlculemedi": (p: MotorP) => `${p.gun} ${p.ad}: ${p.sebep}`,
  "olcu.motorSebepSoylemediAra": () => "the engine gave no reason",
  "olcu.motorSebepSoylemedi": () => "The engine gave no reason.",
  "olcu.seriBos": () => "The series is empty.",
  "olcu.dunEldeVarlikYok": () => "No assets were held yesterday; no daily rate.",
  "olcu.sonYilEldeVarlikYok": () => "No assets were held in the last year; no rate.",

  "olcu.gunHesaplanmamis": (p: MotorP) => `${p.gun} not calculated.`,
  "olcu.gunDegeriOlculemedi": (p: MotorP) => `Value for ${p.gun} could not be measured.`,
  "olcu.gunGetirisiOlculemedi": (p: MotorP) => `Return for ${p.gun} could not be measured.`,
  "olcu.enAzIkiGun": () => "At least two days are needed for the measures.",
  "olcu.eldeVarlikOlanGunYok": () => "No day in the range with assets held.",
  "olcu.olculemeyenGunler": (p: MotorP) =>
    `${p.sayi} days could not be measured (first: ${p.ilk}); those days were skipped.`,
  "olcu.dususYok": () => "No drawdown in the range.",
  "olcu.olculmusYilYok": () => "No measured year.",
  "olcu.olculmusAyYok": () => "No measured month.",
  "olcu.oynaklikEnAzGun": (p: MotorP) => `Volatility needs at least ${p.sayi} measured days.`,
  "olcu.kiyasSecilmedi": () => "No benchmark series selected.",
  "olcu.araligGetirisiYok": () => "The range has no return.",
  "olcu.kiyasGetirisiOlculemedi": () => "The benchmark series return could not be measured.",
  "olcu.kiyasFiyatYok": (p: MotorP) => `No benchmark price for ${p.tarih}.`,
  "olcu.kiyasKurYok": (p: MotorP) => `No ${p.base}/${p.quote} exchange rate for ${p.tarih}.`,
  "olcu.kiyasBaslangicSifir": () => "The benchmark's starting value is zero.",

  "olcu.kaynaktaFiyatYok": () => "The source has no price for this date.",
  "olcu.fiyatIndirilmedi": () => "The price for this date has not been downloaded yet.",
  "olcu.aracTuruBilinmiyor": () => "The asset type is unknown; cannot tell whether it pays dividends.",
  "olcu.aracTemettuBilgisiYok": () => "No dividend data for this asset; return with dividends cannot be calculated.",
  "olcu.tarihTemettuBilgisiYok": () => "No dividend data for this date; return with dividends cannot be calculated.",
  "olcu.temettuTutariYok": (p: MotorP) => `The source has no amount for the ${p.tarih} dividend.`,
  "olcu.temettuGunuFiyatYok": (p: MotorP) => `No price on the day of the ${p.tarih} dividend.`,
  "olcu.temettuKurYok": (p: MotorP) => `No ${p.base}/${p.quote} exchange rate for the ${p.tarih} dividend.`,
  "olcu.temettuGunuFiyatSifir": (p: MotorP) => `The price on the day of the ${p.tarih} dividend is zero.`,
  "olcu.aracParaBirimiBilinmiyor": () => "The asset's currency is unknown.",
  "olcu.temettuIslenemedi": (p: MotorP) => `Dividend could not be processed: ${p.sebep}`,
  "olcu.kurYok": (p: MotorP) => `No ${p.base}/${p.quote} exchange rate.`,
  "olcu.periyotBasiVeriOncesi": (p: MotorP) =>
    `The start of the period (${p.gun} days earlier) is before the data starts on ${p.ilkVeri}.`,
  "olcu.periyotBasiDegerYok": (p: MotorP) => `No value at the start of the period (${p.gun} days earlier): ${p.sebep}`,
  "olcu.periyotBasiDegerSifir": () => "The value at the start of the period is zero; no rate.",
  "olcu.degerYok": () => "No value.",
  "olcu.degerYokAra": () => "no value.",
  "olcu.araliktaHicDegerYok": (p: MotorP) => `No value at all in this range: ${p.sebep}`,
  "olcu.veriBasliyor": (p: MotorP) => `Data starts on ${p.tarih}.`,
  "olcu.sepetKurulmadi": () => "The basket has not been set up yet.",
  "olcu.sepetVarlikDegerYok": (p: MotorP) => `An asset in the basket has no value: ${p.sebep}`,
  "olcu.ortalamaIcinGunYok": (p: MotorP) => `Not yet ${p.sayi} trading days for the average.`,
  "olcu.sepetVerisizVarliklar": (p: MotorP) => `These assets have no value at all in this range: ${p.varliklar}.`,
  "olcu.temettuTutarlariYokNot": (p: MotorP) =>
    `The dividend amount dated ${p.tarihler} is missing at the source; returns covering that date were not computed.`,
};
